module.exports = __webpack_public_path__ + "ea0c421b2a5aecf66e5cd877c20de1a9.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/cancel@2x.png
 ** module id = 192
 ** module chunks = 0
 **/